@if (control) {
  <div class="u-relative">
    <!--
    Custom input option is exposed to allow higher-level components access to the native input element
    while preserving reusability of form-control components label/error/etc. templating.
    Examples include custom form components that implement ControlValueAccessor that need the native input
    -->
    @if (customInputTemplate) {
      <ng-container *ngTemplateOutlet="customInputTemplate"></ng-container>
    } @else {
      <input
        #input
        tabindex="0"
        (focusout)="focusOutEvent.emit($event)"
        (focus)="focusEvent.emit($event)"
        class="form-control"
        ngDefaultControl
        [readOnly]="config.readonly"
        [attr.readonly]="config?.isDisabled ? config?.isDisabled : null"
        [attr.aria-label]="config.ariaLabel"
        [attr.aria-invalid]="
          (control.dirty || control.touched) && !control.valid
        "
        [attr.aria-required]="
          config?.validators && config?.validators.includes('required')
            ? true
            : false
        "
        [attr.autocomplete]="autocomplete !== null ? autocomplete : true"
        [attr.placeholder]="config.placeholder ? config.placeholder : null"
        [attr.type]="config.type"
        [formControl]="control"
        [id]="config.id || config.prop"
        [max]="config.max || null"
        [maxlength]="config.maxLength || ''"
        [name]="config.prop || config.name"
        [type]="cantSeePassword ? 'password' : 'text'"
        (keydown)="
          (config.type === 'number'
            ? $event.key !== 'e' && $event.key !== 'E'
            : true)
        "
        (input)="onInputChange()"
      />
    }
    @if (config.canToggle) {
      <div class="form-control__icon form-control__icon--right">
        @if (canToggle) {
          <icon
            name="eye_active_hide"
            (click)="onEyeIconClick()"
            [config]="{ type: 'pointer' }"
          >
          </icon>
        } @else {
          <icon
            name="eye_active"
            (click)="onEyeIconClick()"
            [config]="{ type: 'pointer' }"
          >
          </icon>
        }
      </div>
    }
  </div>
}
